/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";

import CRMMailTemplateHeader from "../CRMMailTemplateHeader/CRMMailTemplateHeader";
import MailTemplateFilterPopup from "components/Common/Popup/MailTemplateFilterPopup";
// import SaveMailTemplatePopup from "../Popup/SaveMailTemplatePopup";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import TabsHeader from "components/Common/TabsHeader/TabsHeader";

import { crmCommonHeaderLinkLists } from "helper/CrmHelper/CrmHelper";
import { assetImages } from "constants";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import { replaceListByIds } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";

const CRMMailTemplateBody = () => {
  const token = localStorage.getItem("token"); // token
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: "CRM", link: "/admin/crm/mailtemplate/list" },
    { title: t("Mail Template") },
  ];

  // common header object
  const commonHeaderObject = crmCommonHeaderLinkLists(t);

  const [tagList, setTagList] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query — starts as null so we can distinguish
  // "not yet decided" vs "decided: no filter"
  // null   = filter popup hasn't told us what to do yet (skip API call)
  // []     = filter popup said: no default filter, fetch all
  // [...]  = filter popup said: use these filters
  const [jsonFilterQuery, setJsonFilterQuery] = useState(null);

  //* alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [lastPagination, setLastPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const getAllMailTemplates = async (isFilter, filterQuery = []) => {
    setIsLoading(true);

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MAIL_TEMPLATES +
        `?modulename=crm`;

      requestUrl += `&isfilter=${isFilter}`;

      if (filterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = filterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      const response = await getData(requestUrl);

      console.log("response getAllMailTemplates", response);

      setIsLoading(false);
      if (response.status) {
        setTemplateList(response.data);

        setMessageType("success");
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    } finally {
      setShowAlert(true);
      setIsDataReady(true);
    }
  };

  //function for change status
  const changeStatusHandler = async () => {
    if (selectedTemplateIds.length > 0) {
      let responseArr = [];

      for (let selectedId of selectedTemplateIds) {
        try {
          let templateData = {
            status: "0",
          };

          let requestUrl =
            url.API_BASE_URL +
            url.API_UPDATE_MAIL_TEMPLATE +
            `/${selectedId}` +
            ``;

          const response = await putData(requestUrl, templateData);

          if (response.status) {
            setMessageType("success");
            responseArr.push(true);
          } else {
            setMessageType("error");
          }

          setAlertMessage(response.message);
        } catch (error) {
          setMessageType("error");
          setAlertMessage(error.message);
        }
        setShowAlert(true);
      }

      if (responseArr.length > 0) {
        setTimeout(() => {
          getAllMailTemplates();
        }, 2000);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select template for delete");
      setShowAlert(true);
    }
  };

  // function for remove tag from template
  const removeTagFromTemplate = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_TAG_TO_TEMPLATE;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedTemplateId(null);
      }, 1000);
    }
  };

  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setTemplateList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  const initialTableColumns = [
    {
      accessorKey: "#",
      header: t("Actions"),
      Cell: ({ row }) => (
        <Link
          to={`/admin/crm/mailtemplate/save/${row.original._id}`}
          className="action_btn_mui"
          aria-controls="addTask_view"
        >
          <span className="d-block material-symbols-outlined horz_icon">
            more_horiz
          </span>
        </Link>
      ),
      enableColumnActions: false, // Hides the column action icon
      enableColumnDragging: false, // Hides the move icon
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: t("Template Name"),
    },
    {
      accessorKey: "tagstring",
      header: t("Label"),
      Cell: ({ row }) => (
        <div className="label-wrapper py-1">
          <div className="d-flex gap-2">
            <div
              className={
                row.original.tags && row.original.tags.length > 0
                  ? "label-container flex-grow-1"
                  : "d-none"
              }
            >
              <ul
                className="d-flex flex-wrap gap-2 m-0 p-0"
                style={{ listStyle: "none" }}
              >
                {row.original.tags &&
                  row.original.tags.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedTemplateId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromTemplate([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedTemplateId &&
                          selectedTemplateId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
              </ul>
            </div>
            <button
              className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
              style={{ width: "24px", height: "24px" }}
              data-bs-toggle="modal"
              data-bs-target="#addLabelModal"
              onClick={() => setSelectedTemplateIds([row.original._id])}
            >
              <span
                className="material-symbols-outlined text-primary"
                style={{ fontSize: "16px" }}
              >
                add
              </span>
            </button>
          </div>
        </div>
      ),
    },
    {
      accessorKey: "slug",
      header: t("Slug"),
    },
    {
      accessorKey: "ownername",
      header: t("Owner"),
    },
    {
      accessorKey: "createdate",
      header: t("Date"),
    },
  ];

  /*
   * Material React Table Column and States
   */
  const columns = useMemo(
    () => initialTableColumns,
    [i18n.language, templateList, selectedTagId, selectedTemplateId],
  );

  const initialVisibilityState = initialTableColumns.reduce((acc, column) => {
    acc[column.accessorKey] = true;
    return acc;
  }, {});

  const [visibleColoumns, setVisibleColoumns] = useState(
    initialVisibilityState,
  );

  const onColumnVisiblityHandler = (newColumnState) => {
    const newColumnStateName = newColumnState();
    setVisibleColoumns((prev) => ({ ...prev, ...newColumnStateName }));
  };

  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];
  const [columnOrder, setColumnOrder] = useState(initialColumnOrder);

  const changeColumnOrderHandler = (changedOrder) =>
    setColumnOrder(changedOrder);

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key],
    );
    if (selectedIdsArray.length > 0) {
      setSelectedTemplateIds(selectedIdsArray);
    } else {
      setSelectedTemplateIds([]);
    }
  }, [rowSelection]);

  // Pagination save effect
  useEffect(() => {
    if (pagination.pageIndex > 0 || pagination.pageSize > 10) {
      setLastPagination({
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      });
    }
  }, [pagination.pageIndex, pagination.pageSize]);

  //* This is a function that is called when the alert close button is clicked.
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  // ✅ Single API trigger — fires only after filter popup has decided what to do.
  // jsonFilterQuery starts as null (popup not ready yet).
  // Popup sets it to [] (no default filter → fetch all) or [...] (has filters → fetch filtered).
  // This way only ONE api call happens — never two.
  useEffect(() => {
    if (jsonFilterQuery === null) return; // Popup hasn't responded yet, wait

    if (jsonFilterQuery?.length > 0) {
      getAllMailTemplates(true, jsonFilterQuery); // Filter query exists → filtered fetch
    } else {
      getAllMailTemplates(false, []); // No filter → fetch all
    }

    setIsDataReady(true);
  }, [jsonFilterQuery]);

  // Reload effect — triggered by reset or refresh button
  useEffect(() => {
    if (reloadData) {
      setIsFilterReset(true);
      getAllMailTemplates(false, []);
      setReloadData(false);
      setIsDataReady(true);
    }
  }, [reloadData]);

  //function for reset filter
  const resetFilterData = () => {
    setRowSelection({});
    setSelectedTemplateIds([]);
    setIsFilterReset(true);
    setJsonFilterQuery(null);
    setLastPagination({ pageIndex: 0, pageSize: 10 });
    setPagination({ pageIndex: 0, pageSize: 10 });
    setReloadData(true);
  };

  const refreshRecords = () => {
    resetFilterData();
    columnReset();
  };

  const columnReset = () => {
    setVisibleColoumns(initialVisibilityState);
    setColumnOrder(initialColumnOrder);
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") &&
      moduleAccess.includes("MOD_MAIL_TEMPLATE"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderObject}
            activeOption={t("Mail Templates")}
          />
          <div className="container-fluid px-lg-5">
            <CRMMailTemplateHeader
              breadcrumbText={breadcrumbText}
              reloadMailTemplate={refreshRecords}
              jsonFilterQuery={jsonFilterQuery ?? []}
              selectedTemplateIds={selectedTemplateIds}
            />
            {isLoading || !isDataReady ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={templateList}
                  enableGrouping
                  enableRowSelection
                  getRowId={(row) => `${row._id}`}
                  onRowSelectionChange={setRowSelection}
                  state={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  onPaginationChange={setPagination}
                  initialState={{
                    rowSelection,
                    pagination: lastPagination,
                    columnVisibility: visibleColoumns,
                    columnOrder: columnOrder,
                  }}
                  enableColumnOrdering={true}
                  onColumnVisibilityChange={onColumnVisiblityHandler}
                  onColumnOrderChange={changeColumnOrderHandler}
                  defaultColumn={{ minSize: 20, maxSize: 300, size: 50 }}
                  muiTableContainerProps={{ sx: { maxHeight: "60vh" } }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
          {/* ==== modals and popup section === */}
          {/* --- filter popup --- */}
          <MailTemplateFilterPopup
            moduleSlug="crm_mail_template"
            visibleColoumns={visibleColoumns}
            setVisibleColoumns={setVisibleColoumns}
            columnOrder={columnOrder}
            setColumnOrder={setColumnOrder}
            setJsonFilterQuery={setJsonFilterQuery}
            reloadList={refreshRecords}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
            columns={columns}
          />
          {/* --- edit template popup --- */}
          {/* <SaveMailTemplatePopup
            afterPopupClose={getAllMailTemplates}
            templateId={templateId}
            setTemplateId={setTemplateId}
          /> */}

          <AddLabelModal
            moduleName="crmtemplate"
            selectedIds={selectedTemplateIds}
            afterTagModalClose={afterModalActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            selectedTagId={selectedTagId}
            setSelectedTagId={setSelectedTagId}
            removeTagFromLead={() => {}}
            userInfo={userInfo}
            onModalClose={() => {
              setRowSelection({});
              setSelectedTemplateIds([]);
            }}
          />

          {/* ----------- delete warning modal ------------ */}
          <DeleteWarningModal
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedTemplateIds([]);
            }}
            onDelete={changeStatusHandler}
            moduleName={t("mail template")}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};
export default CRMMailTemplateBody;
